import React from "react";
import clsx from "clsx";

import StudentLink from "./StudentLink";
import * as styles from "./styles/NavButtonWrapper.module.css";

type NavButtonWrapperProps = {
	children: React.ReactNode;
	className?: string;
	linkTo?: string;
	isExternal?: boolean;
	isDisabled?: boolean;
	onClick?: (
		event: React.MouseEvent<HTMLDivElement | HTMLButtonElement>
	) => void;
};

function NavButtonWrapper({
	children,
	className,
	linkTo,
	isExternal,
	isDisabled,
	onClick,
}: NavButtonWrapperProps) {
	const wrapperClasses = clsx(styles?.root, className, {
		[styles?.disabled]: isDisabled,
	});

	if (linkTo) {
		return (
			<div onClick={onClick}>
				<StudentLink
					to={linkTo}
					isExternal={isExternal}
					isNewTab={isExternal}
					className={wrapperClasses}
					useWonkyCursor={true}
					disabled={isDisabled}
				>
					{children}
				</StudentLink>
			</div>
		);
	}

	return (
		<button onClick={onClick} className={wrapperClasses} disabled={isDisabled}>
			{children}
		</button>
	);
}

export default NavButtonWrapper;
